// service/getStudentsEnrolledInCourse.js
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase-config";

/**
 * Returns students who truly belong to the given package+batch.
 * - `module` entries are IGNORED for eligibility (they're just installment records).
 * - Both package AND batch must be present (approved) in buyItemIdsArray.
 * - Accepts string or array for packageId / batchId (handles doc.id vs business id).
 */
export async function getStudentsEnrolledInModule({
  packageId,
  batchId,
  // courseId, settingId, moduleId, trainerId — accepted but not used for eligibility
  requireApproved = true,
}) {
  // normalize to arrays of strings
  const toArr = (v) => (Array.isArray(v) ? v : [v]).filter(Boolean).map(String);
  const pkgIds = toArr(packageId);
  const batchIds = toArr(batchId);
  console.log(packageId, batchId);

  const usersSnap = await getDocs(collection(db, "users"));
  const rows = [];

  usersSnap.forEach((docSnap) => {
    const u = docSnap.data() || {};
    const buys = Array.isArray(u.buyItemIdsArray) ? u.buyItemIdsArray : [];

    const ok = (it) => (requireApproved ? (it?.status || "").toLowerCase() === "approved" : (it?.status || "") !== "pending");

    const hasPackage = buys.some(
      (it) =>
        it?.buyItemType === "package_lc" &&
        ok(it) &&
        pkgIds.includes(String(it?.buyItemId))
    );

    const hasBatch = buys.some(
      (it) =>
        it?.buyItemType === "batch" &&
        ok(it) &&
        batchIds.includes(String(it?.buyItemId))
    );
    console.log("Before passing");

    // ✅ Eligibility rule: must have BOTH package & batch
    console.log(hasPackage, hasBatch);

    if (!(hasPackage && hasBatch)) return;
    console.log("Did I pass?");

    const name =
      u.fullname ||
      u.fullName ||
      u.name ||
      u.displayName ||
      [u.firstName, u.lastName].filter(Boolean).join(" ") ||
      u.email ||
      "N/A";

    rows.push({
      id: docSnap.id,
      studentId: docSnap.id,
      studentName: name,
      email: u.email || "",
      // attendance fields are filled by the trainer UI later
    });
  });

  return rows;
}
